/* eslint-disable no-unused-vars */
/* eslint-disable indent */

import React, { useState, useEffect } from "react";
import { StarOutlined } from "@ant-design/icons";
import {
  Form,
  Col,
  Row,
  Menu,
  Button,
  message,
  Upload,
  Spin,
  Modal,
} from "antd";
import PropTypes from "prop-types";
import { checkNumbervalue } from "../../utils";
import constants from "../../constants/messages";
import axios from "axios";
import NonDox from "./NonDox";
import Dox from "./Dox";
import activeListData from "../../store/activeGstNumbers.json";
import { APIs, getToken } from "../../utils/worker";
import uploadLogo from "../../assests/images/bx_upload.svg";
import vector from "../../assests/images/Vector.svg";
import "../../commonStyles/stepButton.css";
import "../../commonStyles/global.css";
import "./style.scss";

const { Dragger } = Upload;
const { UPLOAD_FILES } = constants;
const transporterId = "06AAPCS9575E1ZR";
const ServiceDetails = ({ screen, currentScreen }) => {
  const [form] = Form.useForm();
  const [details, setDetails] = useState();
  const [userInfo, setUserInfo] = useState();
  const [gst, setGst] = useState(false);
  const [stateDetails, setStateDetails] = useState([]);
  const [chargeError, setChargeError] = useState(false);
  const [formLayout, setFormLayout] = useState("vertical");
  const [priceValue, setPriceValue] = useState();
  const [cessTotal, setCessTotal] = useState();
  const [fileList, setfileList] = useState([]);
  const [file, setfile] = useState("");
  const [valueInput, setValueInput] = useState(0);
  const [loading, setLoading] = useState(false);
  const [fileHandleValue, setFileHandleValue] = useState();
  const [descriptionValue, setDescriptionValue] = useState(
    details?.descriptions
  );
  const [senderGstNubmer, setSenderGstNumber] = useState(null || "");
  const getGst = JSON.parse(localStorage.getItem("userId"));
  const [cessChange, setCessChange] = useState(false);
  const chargesMain = form.getFieldValue("charges");

  let objectDate = new Date();
  let day = objectDate.getDate();
  let month = objectDate.getMonth() + 1;
  let year = objectDate.getFullYear();
  let hour = objectDate.getHours();
  let munite = objectDate.getMinutes();
  let second = objectDate.getSeconds();
  const todayTime = `${day}/${month < 10 ? 0 : ""}${month}/${year} ${
    hour > 12 ? hour - 12 : hour
  }:${munite < 10 ? 0 : ""}${munite}:${second} ${hour > 12 ? "PM" : "AM"}`;
  const {
    docType,
    valueInr,
    weight,
    content,
    description,
    selectedMode,
    values,
    width,
    height,
    totalVolWeight,
    senderGst,
    volWeight,
    charges,
    igst,
    sgst,
    cgst,
    freight,
    value,
    Length,
    awbNumber,
  } = details || {};
  // useEffect(() => {
  //   if (currentScreen === 3) {
  //     stateDetailsGet();
  //   }
  // }, [currentScreen]);
  useEffect(() => {
    setDetails(JSON.parse(localStorage.getItem("details")));
    setUserInfo(JSON.parse(localStorage.getItem("userId")));
    setLoading(true);
    if (cessChange === false) {
      setLoading(false);
      form.setFieldsValue({
        type: docType,
        service: selectedMode?.mode,
        travelBy:
          selectedMode?.type?.charAt(0).toUpperCase() +
          selectedMode?.type?.slice(1),
        value: valueInr || 0,
        Weight: weight,
        content: content?.charAt(0).toUpperCase() + content?.slice(1),
        descriptions: description,
        length: values?.length,
        width: width,
        height: height,
        volumetricWeight: totalVolWeight,
        senderGst: senderGst || senderGstNubmer,
        senderPan: "",

        igst: parseFloat(chargesMain * 0.18).toFixed(2) || 0,
        sgst: parseFloat(chargesMain * 0.09).toFixed(2) || 0,
        cgst: parseFloat(chargesMain * 0.09).toFixed(2) || 0,

        freight: selectedMode?.estimatedPriceWithId?.estimatedPrice || 0,
      });
    } else {
      setLoading(false);
      form.setFieldsValue({
        type: docType,
        service: selectedMode?.mode,
        travelBy:
          selectedMode?.type?.charAt(0).toUpperCase() +
          selectedMode?.type?.slice(1),
        value: valueInr,
        Weight: weight,
        content: content,
        descriptions: description,
        length: values?.length,
        width: width,
        height: height,
        volumetricWeight: volWeight,
        senderGst: senderGst || senderGstNubmer,
        senderPan: "",
        charges: charges || 0.0,
        igst: igst || 0,
        sgst: sgst || 0,
        cgst: cgst || 0,
        freight: freight,
      });
    }
  }, [currentScreen]);

  useEffect(() => {
    window.scrollTo(0, 0);
    form.setFieldsValue({
      charges:
        parseFloat(
          (parseInt(selectedMode?.estimatedPriceWithId?.estimatedPrice) * 100) /
            118
        ).toFixed(2) || 0,
    });
  }, [currentScreen]);

  useEffect(() => {
    let oldDetails = JSON.parse(localStorage.getItem("details"));
    let newDetails = !gst
      ? { ...oldDetails, igst: "00.00" }
      : { ...oldDetails, sgst: "00.00", cgst: "00.00" };
    localStorage.setItem("details", JSON.stringify(newDetails, "details"));
  }, []);

  useEffect(() => {
    form.setFieldsValue({
      igst: parseFloat(chargesMain * 0.18).toFixed(2) || 0,
      sgst: parseFloat(chargesMain * 0.09).toFixed(2) || 0,
      cgst: parseFloat(chargesMain * 0.09).toFixed(2) || 0,
    });
  }, [chargesMain]);

  const beforeUpload = (file, onSuccess) => {
    const isJpgOrPng =
      file.type === "image/jpeg" ||
      file.type === "image/png" ||
      file.type === "application/pdf";
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (file) {
      let checkSameFile = fileList
        ?.map((val) => val?.name)
        .some((val) => val === file.name);

      if (file.name.includes("jfif")) {
        message.error("File not supported");
        return Upload.LIST_IGNORE;
      }
      if (checkSameFile) {
        message.error("Same file cannot be uploaded again");
        return Upload.LIST_IGNORE;
      }
      if (!isLt2M) {
        message.error("File size should be less than 2MB");
        return Upload.LIST_IGNORE;
      }
      if (!isJpgOrPng) {
        message.error("File not supported");
        return Upload.LIST_IGNORE;
      }
      return isJpgOrPng && isLt2M;
    } else {
      if (onSuccess) {
        message.success("File uploaded");
      }
      onSuccess("ok");
      return true;
    }
  };

  let authToken = getToken();

  const props = {
    name: "files",
    multiple: true,
    listType: "picture",
    showUploadList: true,

    action: `${APIs.baseURL}/file-service/v1/file`,
    headers: { Authorization: `Bearer ${authToken}` },

    // headers: {
    //   Authorization: authToken,
    // },
    className: "upload-list-inline",
    onDrop(e) {
      console.log("Dropped files", e.dataTransfer.files);
    },

    onChange(info) {
      if (info.file.status === "done") {
        // Handle response from API
      }
    },

    removeIcon: (
      <StarOutlined
        onClick={(e) => console.log(e, "custom removeIcon event")}
      />
    ),
  };

  const inptHandler = (e) => {
    const val = e.target.value;
    setSenderGstNumber(val);
    if (+val.substring(0, 2) === +getGst?.premises?.gst?.substring(0, 2)) {
      setGst(true);
    } else {
      setGst(false);
    }
  };

  // const stateDetailsGet = async () => {
  //   try {
  //     let res = await axios.get(`${APIs.baseURL}/gst-service/gstDetails`);
  //     if (res) {
  //       setStateDetails(res);
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  const onCESSChange = () => {
    let Charges = form.getFieldValue("charges");
    let CESS = form.getFieldValue("cess");
    let IGST = Math.round((Number(Charges) * 18) / 100);
    let total = Number(Charges) + Number(IGST) + Number(CESS);

    setCessChange(true);
    setCessTotal(total);

    return form.setFieldsValue({
      freight: Math.round(total),
    });
  };

  function handleNext() {
    if (fileList.length === 0) {
      localStorage.setItem("allFiles", JSON.stringify([]));
    }
    localStorage.setItem("filesLength", JSON.stringify(fileList?.length));
    return screen(4);
  }

  function handleBack() {
    screen(2);
  }

  const onSubmitFormData = (values) => {
    let oldDetails = JSON.parse(localStorage.getItem("details"));
    delete oldDetails.charges;
    delete oldDetails.cgst;
    delete oldDetails.igst;
    delete oldDetails.sgst;
    delete oldDetails.freight;

    if (!chargeError) {
      let newDetails = !gst
        ? {
            ...oldDetails,
            ...values,
            igst: values?.igst,
            priceValue: priceValue,
          }
        : {
            ...oldDetails,
            ...values,
            igst: values?.igst,
            cgst: values?.cgst,
            sgst: values?.sgst,
            priceValue: priceValue,
          };

      localStorage.setItem("details", JSON.stringify(newDetails));

      handleNext();
    }
  };

  const formProps = {
    name: "register-login",
    className: "register-form",
    onFinish: onSubmitFormData,
    autoComplete: "off",
  };

  const onFreightChange = (e) => {
    let editedFreight = (parseInt(e.target.value) * 100) / 118;
    setPriceValue(editedFreight);
    return form.setFieldsValue({
      charges: parseFloat(editedFreight).toFixed(2),
      igst: parseFloat(chargesMain * 0.18).toFixed(2) || 0,
      sgst: parseFloat(chargesMain * 0.09).toFixed(2) || 0,
      cgst: parseFloat(chargesMain * 0.09).toFixed(2) || 0,
    });
  };

  const handleMenuClick = (e) => {
    setDescriptionValue(e?.key);
  };

  const [uploadedRes, setUploadedRes] = useState([]);

  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [previewTitle, setPreviewTitle] = useState("");

  const handlePreview = async (file) => {
    if (file.response.data.displayName.split(".")[1] == "pdf") {
      window.open(file.response.data.filePath);
    } else {
      let imagePath = uploadedRes.filter(
        ({ id }) => file?.response?.data?.id === id
      )[0].filePath;
      setPreviewImage(imagePath);
      setPreviewOpen(true);
      setPreviewTitle(
        file.name || file.url.substring(file.url.lastIndexOf("/") + 1)
      );
    }
  };
  const handleCancel = () => setPreviewOpen(false);

  const handleChange = (info) => {
    let allFiles = info?.fileList?.map((val) => val?.response?.data);
    // let v1 = allFiles?.map((val) => val?.displayName);

    if (info.file.status === "done") {
      message.success(info.file.response.message);
      setUploadedRes(allFiles);
      localStorage.setItem("allFiles", JSON.stringify(allFiles));
    }
    if (info.file.status === "removed") {
      setUploadedRes(allFiles);

      localStorage.setItem("allFiles", JSON.stringify(allFiles));
    }
    if (info.file.status === "error") {
      message.error("File not Supported");
    }
    setfileList(info.fileList);
    setfile({ selectedType: fileHandleValue, info });
  };

  const handleRemove = (file) => {
    const { confirm } = Modal;
    let config = {
      headers: {
        Authorization: authToken,
      },
    };
    return new Promise((resolve, reject) => {
      confirm({
        title: "Are you sure you want to Delete ?",
        onOk: async () => {
          resolve(true);
          try {
            let res = await axios.delete(
              `${APIs.baseURL}/file-service/v1/file/${file?.response?.data?.id}`,
              config
            );

            if (res) {
              message.success(res.data);
            }
          } catch (error) {
            // message.error(error.data + "world");
          }
        },
        onCancel: () => {
          reject(true);
        },
      });
    });
  };

  useEffect(() => {
    setValueInput(valueInr);
  }, [screen]);

  const menu = (
    <Menu
      onClick={handleMenuClick}
      items={[
        {
          label: "Form, Catalogue & Papers",
          key: "Forms, Catalogue & Paper",
        },
        {
          label: "Passport",
          key: "Passport",
        },
        {
          label: "Tender Document",
          key: "Tender Document",
        },
      ]}
    />
  );
  const contentMenu = (
    <Menu
      items={[
        {
          label: "Document",
          key: "Document",
        },
      ]}
    />
  );
  const [showForm] = useState(true);
  return (
    <div>
      <Modal
        open={previewOpen}
        title={previewTitle}
        footer={null}
        onCancel={handleCancel}
      >
        <img
          alt="example"
          style={{
            width: "100%",
          }}
          src={previewImage}
        />
      </Modal>
      {showForm && details ? (
        <Form
          {...formProps}
          layout={formLayout}
          form={form}
          scrollToFirstError={{
            behavior: "smooth",
            block: "center",
            inline: "center",
          }}
          initialValues={{
            layout: formLayout,
            type: docType,
            service: selectedMode?.mode,
            travelBy:
              selectedMode?.type?.charAt(0).toUpperCase() +
              selectedMode?.type?.slice(1),
            value: value || 0,
            weight: weight,
            Weight: weight || 0,
            length: Length,
            width: width,
            height: height,
            volumetricWeight: totalVolWeight,

            charges:
              parseFloat(
                (parseInt(selectedMode?.estimatedPriceWithId?.estimatedPrice) *
                  100) /
                  118
              ).toFixed(2) || 0,

            freight: selectedMode?.estimatedPriceWithId?.estimatedPrice || 0,
          }}
          className="service-container"
        >
          <div className="service-form mainForm">
            {docType === "NON-DOX" ? (
              <NonDox
                contentMenu={contentMenu}
                vector={vector}
                descriptionValue={descriptionValue}
                menu={menu}
                valueInput={valueInput}
                RegExp={RegExp}
                inptHandler={inptHandler}
                parseInt={parseInt}
                details={details}
                setChargeError={setChargeError}
                chargeError={chargeError}
                gst={gst}
                onCESSChange={onCESSChange}
                onFreightChange={onFreightChange}
                activeListData={activeListData}
                screen={screen}
                transporterId={transporterId}
                todayTime={todayTime}
              />
            ) : (
              <>
                {details ? (
                  <Spin spinning={loading}>
                    <Dox
                      contentMenu={contentMenu}
                      descriptionValue={descriptionValue}
                      menu={menu}
                      RegExp={RegExp}
                      valueInput={valueInput}
                      inptHandler={inptHandler}
                      details={details}
                      parseInt={parseInt}
                      setChargeError={setChargeError}
                      chargeError={chargeError}
                      senderGstNubmer={senderGstNubmer}
                      checkNumbervalue={checkNumbervalue}
                      gst={gst}
                      onCESSChange={onCESSChange}
                      onFreightChange={onFreightChange}
                      activeListData={activeListData}
                      screen={screen}
                      transporterId={transporterId}
                      todayTime={todayTime}
                    />
                  </Spin>
                ) : null}
              </>
            )}
            <h4>{UPLOAD_FILES}</h4>
            <ul>
              <li>
                Click the icon or drag and drop to upload supporting documents
              </li>
              <li>
                Supported file type: PDF, JPEG, PNG and Max 10MB file size
              </li>
            </ul>
            <Row className="upload_and_dragger">
              <Col>
                <div className="one-row">
                  <Dragger
                    {...props}
                    className="dragger"
                    onChange={handleChange}
                    onRemove={handleRemove}
                    maxCount={10}
                    fileList={fileList}
                    beforeUpload={beforeUpload}
                    onPreview={handlePreview}
                    multiple={false}
                    headers={{
                      "SMCS-PREMISE-ID": userInfo?.premiseId,
                      awbNumber: awbNumber,
                      Authorization: authToken,
                    }}
                  >
                    <Row>
                      <Col span={6}>
                        <img src={uploadLogo} className="Upload_logo" />
                      </Col>
                      <Col span={1} className="vline"></Col>
                      <Col span={17}>
                        <p>Choose file</p>
                      </Col>
                    </Row>
                  </Dragger>
                </div>
              </Col>
            </Row>
          </div>
          <Row className="button-container">
            <Col span={24}>
              <div className="steps-action">
                <Button onClick={() => handleBack()} className="back-button">
                  {"BACK"}
                </Button>
                <Button htmlType="submit" className="next-button srvs">
                  {"NEXT"}
                </Button>
              </div>
            </Col>
          </Row>
        </Form>
      ) : null}
    </div>
  );
};

export default ServiceDetails;

ServiceDetails.PropTypes = {
  screen: PropTypes.number,
  currentScreen: PropTypes.number,
};
